import React, { useState, useEffect } from 'react';
import {Redirect} from "react-router-dom";
import auth from '../../../service/Auth';
import { downloadCSV } from '../../../service/CsvButton';
import {status_list_experiments, files_by_experiment} from '../../../service/apis';
import settings from '../../../DataManagementConfig';
import TableView from '../components/TableView';

const config = window.config;

const ExperimentStatusInfo = (props) => {

    const [title, setTitle] = useState("");
    const [errors, setErrors] = useState("");
    const [goBack, setGoBack] =  useState(false);
    const [loading, setLoading] =  useState(true);
    const [experimentsStatus, setExperimentsStatus] = useState({});
    const [experimentsFiles, setExperimentsFiles] = useState({});
    const [headers, setHeaders] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]); 

    const fetchFilesByExperiment = async (experiments) => {
        let experiments_files = {};
        await files_by_experiment(auth.getToken(),config.api_endpoint,experiments.join(','))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            if (Object.entries(data).length !== 0) {
               for (let experiment of experiments) {
                   let file_names = [];
                   if (experiment in data){
                       for (let file_object of data[experiment]) {
                           file_names.push(file_object.filePath);
                       }
                   }
                   experiments_files[experiment] = file_names;
               }
            }
        });
        setExperimentsFiles(experiments_files);
        setTitle("Experiments Declared for group " + props.location.group);
        setLoading(false);
    }

    const fetchStatusListExperiments = async (body, experiments) => {
        // GET Complete Status Fields
        await status_list_experiments(auth.getToken(),config.api_endpoint,JSON.stringify(body),experiments)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setExperimentsStatus(data["items"]);
            setTitle("Experiments In Process for group " + props.location.group);
            setLoading(false);
        });
    }

    useEffect(() => {
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else if (props.location.type === "group") {
            setTitle("Experiments to process for group " + props.location.group); 
            setLoading(false);          
        }
        else if (props.location.type === "total_declared") {
            if ("declared" in props.location.apiInfo[props.location.group]) {
                let experiments = props.location.apiInfo[props.location.group]["declared"];
                fetchFilesByExperiment(experiments); 
            }         
        }
        else if (props.location.type === "total_inprocess") {
            if ("inprocess" in props.location.apiInfo[props.location.group]) {
                let experiments = props.location.apiInfo[props.location.group]["inprocess"];
                let data_post = {"page": 1, "pageSize": settings.apiExperimentCSVPageSize,
                                 "fields": ["RD_Connect_ID_Experiment","rawUpload","rawDownload", 
                                            "receptionPipeline","mapping", "cram",
                                            "variantCalling", "cnv", "rohs"],
                                 "filtered": []
                }
                fetchStatusListExperiments(data_post, experiments);
            }
        }   
        else if (props.location.type === "total_gvcf") {
            setTitle("Experiments gVCF Ready for group " + props.location.group);
            setLoading(false);
        } 
        else if (props.location.type === "total_failed") {
            if ("failed" in props.location.apiInfo[props.location.group]) {
                let experiments = props.location.apiInfo[props.location.group]["failed"];
                let data_post = {"page": 1, "pageSize": settings.apiExperimentCSVPageSize,
                                 "fields": ["RD_Connect_ID_Experiment","rawUpload","rawDownload", 
                                            "receptionPipeline","mapping", "cram",
                                            "variantCalling", "cnv", "rohs"],
                                 "filtered": []
                }
                fetchStatusListExperiments(data_post, experiments);
            }
        }      
    },[])

    const updateColumns = () => {
        // Translates API Data result to data and columns for react-table
        let cols = [];
        // Header Definition
        let headerTable = [];
        switch (props.location.type) {
            case "group":
                headerTable.push({ label: "Experiment" , key: "experiment",tooltip: "Experiment ID."});
                headerTable.push({ label: "Experiment Status" , key: "experiment_status",tooltip: "Experiment."});
                break;
            case "total_declared":
                headerTable.push({ label: "Experiment" , key: "experiment",tooltip: "Experiment ID."});
                headerTable.push({ label: "File List" , key: "file_list",tooltip: "List of files associated to the experiment."});
                break;
            case "total_inprocess":
            case "total_failed":
                headerTable.push({ label: "Experiment" , key: "experiment",tooltip: "Experiment ID."});
                headerTable.push({ label: "Raw Upload" , key: "rawUpload",tooltip: "Data updated to Red Iris."});
                headerTable.push({ label: "Raw Download" , key: "rawDownload",tooltip: "Data download to CNAG cluster."});
                headerTable.push({ label: "Reception Pipeline" , key: "receptionPipeline",tooltip: "Quality control on the experiment files."});
                headerTable.push({ label: "Mapping" , key: "mapping",tooltip: "Experiment being aligned to a reference genome."});
                headerTable.push({ label: "Cram" , key: "cram",tooltip: "Experiment archiving and visualization cram files are built."});
                headerTable.push({ label: "SnpCalling" , key: "variantCalling",tooltip: "Variant Calling on the aligned experiment file."});
                headerTable.push({ label: "Copy Number Variance" , key: "cnv",tooltip: "Copy number variance calls."});
                headerTable.push({ label: "Runs Of Homozygosity" , key: "rohs",tooltip: "Runs of Homozygosity calls."});
                break;
            case "total_gvcf":
                headerTable.push({ label: "Experiment" , key: "experiment",tooltip: "Experiment ID."});
                break;
        }
        //Setup Headers
        for (let header of headerTable) {
              let col = {};
              if ("tooltip" in header){
                  col["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
              }
              else{
                  col["Header"] = header.label;
              }
              col["accessor"] = header.key;
              col["minWidth"] = 190;
              cols.push(col);
        }
        setHeaders(headerTable);
        setColumns(cols);
    } 
    
    const updateRows = () => {
        //Build data to render on react-table
        let tableRows = [];
        let groupSelected = props.location.group;
        switch (props.location.type) {
            case "group":
                //1. Get Experiments Declared
                if ("declared" in props.location.apiInfo[groupSelected]) {
                    for (let experiment of props.location.apiInfo[groupSelected].declared) {
                        let row = {};
                        row["experiment"] = experiment;
                        row["experiment_status"] = "Declared";
                        tableRows.push(row);
                    }
                }
                //2. Get Experiments In Process
                if ("inprocess" in props.location.apiInfo[groupSelected]) {
                    for (let experiment of props.location.apiInfo[groupSelected].inprocess) {
                        let row = {};
                        row["experiment"] = experiment;
                        row["experiment_status"] = "In process";
                        tableRows.push(row);
                    }
                }
                //3. Get Experiments gVCF Ready
                if ("gvcf" in props.location.apiInfo[groupSelected]) {
                    for (let experiment of props.location.apiInfo[groupSelected].gvcf) {
                        let row = {};
                        row["experiment"] = experiment;
                        row["experiment_status"] = "gVCF Ready";
                        tableRows.push(row);
                    }
                }
                //4. Get Experiments Failed
                if ("failed" in props.location.apiInfo[groupSelected]) {
                    for (let experiment of props.location.apiInfo[groupSelected].failed) {
                        let row = {};
                        row["experiment"] = experiment;
                        row["experiment_status"] = "Failed";
                        tableRows.push(row);
                    }
                }
                break;
            case "total_declared":
                if (Object.entries(experimentsFiles).length !== 0) {
                    for (let experiment in experimentsFiles) {
                        let row = {};
                        row["experiment"] = experiment;
                        row["file_list"] = (experimentsFiles[experiment].length === 0) ? "" : experimentsFiles[experiment].toString();
                        tableRows.push(row);
                    }
                }
                break;
            case "total_inprocess":
            case "total_failed":
                if (Object.entries(experimentsStatus).length !== 0) {
                    for (let experiment of experimentsStatus) {
                       let row = {};
                       row["experiment"] = experiment.RD_Connect_ID_Experiment;
                       //1. Loop Headers
                       for (let column of columns){
                           if (column.accessor !== "experiment") row[column.accessor] = experiment[column.accessor];
                       }
                       tableRows.push(row);
                    }
                }
                break;
            case "total_gvcf":
                //1. Get Experiments gVCF Ready
                if ("gvcf" in props.location.apiInfo[groupSelected]) {
                    for (let experiment of props.location.apiInfo[groupSelected].gvcf) {
                        let row = {};
                        row["experiment"] = experiment;
                        tableRows.push(row);
                    }
                }
                break;
        }
        // 3.Update Rows
        setRows(tableRows);
    }

    useEffect(() => {
        // 1. Update Table Columns
        updateColumns(); 
        // 2. Update Rows with the updated data memeber
        updateRows();
    },[experimentsFiles, experimentsStatus])

    const goBackButton = () => {
        setGoBack(true);
    }

    const getCsvData = (events) => {
        //1. Trigger CSV
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(rows,headers,`${today}_experiment_status_info.csv`);
    }

    /*Show popup in case an error with the loggin occurs*/
    if (errors !== "") {
        return <PopupMessage title={"Logging error!"} message={errors} href={"#/admin"} />;
    }
    else if(goBack) {
        return <Redirect to={{pathname:'/admin/experimentprogress',data:props.location.apiInfo}} />;
    }
    else {
        return (
            <TableView 
                title = {title}
                goBack = {goBackButton}
                getCsvData = {getCsvData}
                rows = {rows}
                columns = {columns}
                height = {700}
                loading = {loading}
            />
        );        
    }
}

export default ExperimentStatusInfo;
